import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { getUrlConvertedString } from '../../helper';
import { getSubTopicById, getSubTopicState } from '../../store/SubTopicSlice';
import FullScreenLoader from '../../components/Loaders/FullScreenloader';

const ManageOldRoutes: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  // State
  const [redirectUrl, setRedirectUrl] = useState<string>('');

  // Store
  const subTopicState = useAppSelector(getSubTopicState);
  const subTopicData = subTopicState.subTopic;

  const isResource = location.pathname.includes('/resources/');
  const dividedPathname = location.pathname.split('_').reverse();
  const subTopicId = dividedPathname[0] || '';

  useEffect(() => {
    if (subTopicId) {
      dispatch(getSubTopicById(subTopicId));
    }
  }, []);

  useEffect(() => {
    if (subTopicData) {
      const { topic } = subTopicData;
      const urlConvertedCurriculum = getUrlConvertedString(topic.curriculum);
      const urlConvertedSubject = getUrlConvertedString(topic.subject);
      const urlConvertedTopic = getUrlConvertedString(topic.name);
      const urlConvertedSubTopic = getUrlConvertedString(subTopicData.name);

      setRedirectUrl(
        `${
          process.env.PUBLIC_URL
        }/dashboard/${urlConvertedCurriculum}/${urlConvertedSubject}/${urlConvertedTopic}/${urlConvertedSubTopic}/${
          subTopicData._id
        }${isResource ? '' : '/quiz'}`
      );
    }
  }, [subTopicData]);

  if (redirectUrl) {
    return <Navigate to={{ pathname: redirectUrl }} state={{ status: 301 }} />;
  }

  return <FullScreenLoader />;
};

export default ManageOldRoutes;
